export enum QuotationDialogType {
    New,
    Edit
}